
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Menu } from 'lucide-react';
const Header: React.FC = () => {
  const navigate = useNavigate();
  return <header className="bg-slate-900/98 backdrop-blur-xl border-b border-slate-700/50 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <div className="flex items-center space-x-3 cursor-pointer group transition-all duration-300 hover:scale-105" onClick={() => navigate('/')}>
              <img src="/lovable-uploads/d981c4c2-888d-4322-9d83-e527475f379f.png" alt="Flamingo Logo" className="h-8 w-auto" />
            </div>
            
            {/* Desktop Navigation */}
            
          </div>

          <div className="flex items-center space-x-4">
            {/* Mobile Menu */}
            <div className="md:hidden">
              <Sheet>
                <SheetTrigger asChild>
                  <Button variant="ghost" size="sm" className="text-slate-300 hover:text-white hover:bg-slate-800/50">
                    <Menu className="h-5 w-5" />
                  </Button>
                </SheetTrigger>
                <SheetContent side="right" className="w-80 bg-slate-900/98 backdrop-blur-xl border-slate-700/50">
                  <div className="py-6">
                    <div className="mt-8 space-y-4">
                      <Button variant="outline" size="sm" onClick={() => navigate('/login')} className="w-full bg-slate-800/50 border-slate-600/50 text-slate-200 hover:bg-slate-700/50 hover:border-slate-500/50">
                        Sign In
                      </Button>
                      <Button size="sm" onClick={() => navigate('/signup')} className="w-full bg-gradient-to-r from-primary to-pink-500 hover:from-primary/90 hover:to-pink-500/90 text-white font-semibold shadow-lg">
                        Get Started
                      </Button>
                    </div>
                  </div>
                </SheetContent>
              </Sheet>
            </div>

            {/* Desktop Auth Buttons */}
            <div className="hidden md:flex items-center space-x-4">
              <Button variant="outline" size="sm" onClick={() => navigate('/login')} className="bg-slate-800/50 border-slate-600/50 text-slate-200 hover:bg-slate-700/50 hover:border-slate-500/50 transition-all duration-300 hover:scale-105">
                Sign In
              </Button>
              <Button size="sm" onClick={() => navigate('/signup')} className="bg-gradient-to-r from-primary to-pink-500 hover:from-primary/90 hover:to-pink-500/90 text-white font-semibold transition-all duration-300 hover:scale-105 shadow-lg">
                Get Started
              </Button>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default Header;
